import _, { now } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import {Dropdown, Pagination, Dimmer, Loader, Segment, Header, Icon, Table, Button, Grid, Confirm, Modal} from 'semantic-ui-react'
import './DispatchedRequestsContainer.less';
import '../../../assets/css/chkbox-style.css'
import '../../../components/FormControls/Checkbox/DGCheckbox.less'
import { getSellerCustomerRequestsList, updateSellerNotes, sendFormEntrySMSToCustomer, deleteSCRequest, updateSCRequestBookingDate, resetBookedSCRequest } from '../../../services/Seller'
import RequestNotesModal from '../../../components/SellerCustomer/RequestNotesModal/RequestNotesModal';
import RequestInvoiceDetailModal from '../../../components/SellerCustomer/RequestInvoiceDetailModal/RequestInvoiceDetailModal';
import RequestDetailCard from '../../../components/SellerCustomer/RequestDetailCard/RequestDetailCard';
import { format } from 'react-phone-input-auto-format'
import GeneralMessage from '../../../components/GeneralMessage/GeneralMessage';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Calendar from '../../../assets/images/newui/Calendar.svg'
import deleteImg from '../../../assets/images/newui/remove-img.svg'
import { getDispatchedRequestsList, updateDispatchRequestStatus } from '../../../services/Driver';

function CustomerRequestsContainer (props) {
    const [loading, setLoading] = useState(false);
    const [customerRequests , setCustomerRequests] = useState([]);
    const [paginationState, setPaginationState] = useState({
            rowsPerPage: 10,
            activePage: 1,
            recordCount: 0,
    })
    const [requestNotesModalOpen, setRequestNotesModalOpen] = useState(false)
    const [selectedRequest, setSelectedRequest] = useState({});
    const [requestInvoiceDetailModalOpen , setRequestInvoiceDetailModalOpen] = useState(false)
    const [notificationState, setNotificationState] = useState({
        isShow: false,
        type: "",
        message: ""
    });
    const [sendingSms,setSendingSms] = useState(false);
    const [showSendLinkButton,setShowSendLinkButton] = useState(false);

    const [disableAddCustomerRequestButton, setDisableAddCustomerRequestButton] = useState(false)
    const currentUser = useSelector(({ auth }) => auth.currentUser);

    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [showBookModal, setShowBookModal] = useState(false);
    const [showDispatchStatusUpdateModal, setShowDispatchStatusUpdateModal] = useState(false);
    const [selectedDispatchStatus, setSelectedDispatchStatus] = useState(null);
    
    const [bookDate, setBookDate] = useState(null);
    const [selectedServiceID, setSelectedServiceID] = useState(0);
    const [selectedRequestID, setSelectedRequestID] = useState(0);
    const [isBooked, setIsBooked] = useState(false);
    

    let notficationTimeOut = undefined;

    useEffect(() => {
        loadData();
    }, [paginationState.activePage])

    const loadData = async () => {
        setLoading(true);
        let option = paginationState;
        let res =  await getDispatchedRequestsList(option);
        if(res.resStatus == 200)
        {
            setCustomerRequests(res.data.scRequests)
            setPaginationState({...paginationState , recordCount : res.data.scRequestsCount})
        }
        setLoading(false);
    }

    const onPageChange = (e, d) => {
        setPaginationState({...paginationState , activePage : d.activePage })
    }

    const handleRequestNotesClick = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setRequestNotesModalOpen(true)
    }

    const handleRequestNotesModalClose = () => {
        setRequestNotesModalOpen(false);
    }
    
    const onSellerNotesSubmit = async (value) => {
        let res = await updateSellerNotes(selectedRequest.scRequestID, value);
        if(res.resStatus == 200)
        {
            setSellerNotesModalOpen(false);
            loadData();
        }
    }

    const onRequestUpdateButtonClick = (requestToken) => {
        props.history.push(`/customer/request/form/${requestToken}`)
    }

    const onRequestInvoiceDetailButtonClick = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setRequestInvoiceDetailModalOpen(true)
    }

    const handleInvoiceDetailModalClose = () => {
        setRequestInvoiceDetailModalOpen(false);
    }
    const handleCustomerFormEntryLinkSMS = async (scRequestID) => {
        setSendingSms(true);
        let res = await sendFormEntrySMSToCustomer(scRequestID);
        if(res.resStatus == 200)
        {
            setNotificationState({
                isShow : true,
                type : "success",
                message : "Form entry link sms sent successfully to customer."
            })
        }else
        {
            setNotificationState({
                isShow : true,
                type : "error",
                message : res.message
            }) 
        }
        setSendingSms(false);
        if(notficationTimeOut)
        {
            clearTimeout(notficationTimeOut)
        }
        notficationTimeOut = setTimeout(() => {
            setNotificationState({
                isShow:false,
                type : "",
                message : ""
            })
        }, 3500);
    }

    const handleDispatchRequestStatusUpdate = async (dispatchID, statusID) => {

        if (!dispatchID) {
            return
        }
        if (!statusID) {
            return
        }
        let res = await updateDispatchRequestStatus(dispatchID, statusID)
        if (res.resStatus == 200) {
            setNotificationState({
                isShow: true,
                type: "success",
                message: "Dispatch request status updated successfully."
            })
            loadData()
        } else {
            setNotificationState({
                isShow: true,
                type: "error",
                message: res.message
            })
        }

        setShowDispatchStatusUpdateModal(false)
        if (notficationTimeOut) {
            clearTimeout(notficationTimeOut)
        }
        notficationTimeOut = setTimeout(() => {
            setNotificationState({
                isShow: false,
                type: "",
                message: ""
            })
        }, 3500);
    }

    const handleAddCustomerRequestButtonClick = () => {
        props.history.push(`/customer/request/create`)
    }

    const onRequestDeleteButtonClick = (selectedRequest) => {
        setSelectedRequest(selectedRequest);
        setShowDeleteConfirmModal(true)
    }

    const onCloseDeleteConfirmModal = () => {
        setShowDeleteConfirmModal(false)
    }

    const onSCRequestDeleteConfirm = async () => {
        const res = await deleteSCRequest(selectedRequest.scRequestID);
        setShowDeleteConfirmModal(false)
        if(res.resStatus == 200){
            setSelectedRequest({});
            await loadData();
        }
        
    }
    const onBookRequestClicked = (serviceID, bookingDate, requestID) => {
        setBookDate(bookingDate.isValid() ? bookingDate.toDate() : moment().toDate());
        setIsBooked(bookingDate.isValid());
        setSelectedServiceID(serviceID);
        setSelectedRequestID(requestID);
        setShowBookModal(true);

    }

    const onBookingDateChanged = (selectedDateTime) => {
        setBookDate(selectedDateTime);
    }
    const onSubmitBookingDate = async (e, data) => {
        let res = await updateSCRequestBookingDate(bookDate, selectedServiceID, selectedRequestID);
        if(res.resStatus == 200)
        {
            setShowBookModal(false);
            setBookDate(null);
            setSelectedServiceID(0);
            setSelectedRequestID(0)
            loadData();
        }
    }

    const onDeleteBooking = async (e, data) => {
        let res = await resetBookedSCRequest(selectedRequestID);
        if(res.resStatus == 200)
        {
            setShowBookModal(false);
            setBookDate(null);
            setSelectedServiceID(0);
            setSelectedRequestID(0)
            loadData();
        }
    }

    const handleStatusUpdateClick = (request) => {
          if (request?.dispatchRequest?.status.nextStatus && request?.dispatchRequest?.status.nextStatus.length > 0) {
              setSelectedDispatchStatus(request?.dispatchRequest?.status.nextStatus[0].value);
              setSelectedRequest(request);
              setShowDispatchStatusUpdateModal(true);
          }
    }

    return (
        <>
        <div className={"customer-request-container"}>
            {loading ? <Dimmer active>
                <Loader indeterminate size='massive' />
            </Dimmer> : ''}
            <Segment.Group>
                <Segment size="massive" className="no-radius">
                    <Header as="h1">
                        <Header.Content>
                            <Icon name='list' size='small' />
                            Dispatched Request  
                        </Header.Content>
                    </Header>
                </Segment>
            </Segment.Group>
            
            {
               ( customerRequests && customerRequests.length > 0 ) ?
                <>

                    {   window.innerWidth >= 768 ? 
                        <>
                            {
                                notificationState.isShow ? 
                                <GeneralMessage type={notificationState.type} message={notificationState.message}/> : ""
                            }
                            
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Service</Table.HeaderCell>
                                        <Table.HeaderCell>Customer</Table.HeaderCell>
                                        <Table.HeaderCell>Phone</Table.HeaderCell>
                                        <Table.HeaderCell>Dispatch Info</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Booking Info</Table.HeaderCell>
                                        <Table.HeaderCell>Notes</Table.HeaderCell>
                                        <Table.HeaderCell>Quick Info</Table.HeaderCell>  
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        customerRequests.sort((a,b) => moment(b.initiated) -  moment(a.initiated)).map((request, requestIndex) => {
                                            return <>
                                                <Table.Row>  
                                                    <Table.Cell>{request.serviceName}</Table.Cell>
                                                    <Table.Cell>{request.customer.firstName + " " + request.customer.lastName}</Table.Cell>
                                                    <Table.Cell textAlign='center'>
                                                        <a href={"tel:" + request.customer.cellPhone} className="call-link">

                                                            <div>
                                                                <Icon name='phone'></Icon>
                                                            </div>
                                                            <div>
                                                                {request.customer.cellPhone}
                                                            </div>

                                                        </a>
                                                    </Table.Cell>
                                                    
                                                    <Table.Cell>
                                                        {
                                                            request?.dispatchRequest ?
                                                                <>
                                                                    <div style={{ fontWeight: "600" }}>
                                                                        {"Seller:"}
                                                                    </div>
                                                                    <div style={{ marginBottom: "15px" }}>
                                                                        {request?.dispatchRequest?.seller.name || "-"}
                                                                    </div>
                                                                    <div style={{ marginBottom: "15px" }}>
                                                                        <a href={"tel:" + request.dispatchRequest.seller.cellPhone} >
                                                                            <div>
                                                                                <Icon name='phone'></Icon>
                                                                                {request.dispatchRequest.seller.cellPhone ? request.dispatchRequest.seller.cellPhone : "-"}
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                    <div style={{ fontWeight: "600" }}>
                                                                        {"Dispatched At:"}
                                                                    </div>
                                                                    <div style={{ marginBottom: "15px" }}>
                                                                        {request?.dispatchRequest?.dispatchedAt ? moment(request?.dispatchRequest.dispatchedAt).format('LLL') : "-"}
                                                                    </div>
                                                                    <div >
                                                                        <span style={{ fontWeight: "600" }}>
                                                                            {"Status: "}
                                                                        </span>
                                                                        {request?.dispatchRequest?.status.displayName ? request?.dispatchRequest?.status.displayName : "-"}
                                                                        {
                                                                            request?.dispatchRequest?.status.nextStatus &&
                                                                            <span style={{ fontWeight: "600", color: "#377DFF", marginLeft: "5px", fontSize: "12px", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                   handleStatusUpdateClick(request);
                                                                                }}>
                                                                                {"(Update)"}
                                                                            </span>
                                                                        }
                                                                    </div>
                                                                    <div>
                                                                    </div>
                                                                </> :
                                                                "-"
                                                        }

                                                    </Table.Cell>

                                                    <Table.Cell>{request.status.displayName}</Table.Cell>
                                                    <Table.Cell style={{width : "100px"}}>{request.bookingDate ? moment(request.bookingDate).format('LLL') : "-"}</Table.Cell>
                                                    <Table.Cell className={"request-notes-cell"}>
                                                        <div className={"request-notes-cell-container"}>
                                                            {request.lastNote ?
                                                                <>
                                                                    <div className={"request-notes-cell-container-heading"}>
                                                                        {"Latest Note"}
                                                                    </div>
                                                                    <div className={"request-notes-cell-container-text"}>
                                                                        {request.lastNote?.note?.message || "-"}
                                                                    </div>
                                                                    <div className={"request-notes-cell-container-date"}>
                                                                        {request.lastNote?.note?.createdAt ? moment(request.lastNote?.note?.createdAt).format('LLL') : "-"}
                                                                    </div>
                                                                    <div onClick={() => handleRequestNotesClick(request)} className={"request-notes-cell-container-icon"}>
                                                                        Notes {"(" + request?.lastNote?.totalCount + ") > "}
                                                                    </div>
                                                                </>
                                                                : <div className={"request-notes-cell-container-text"}> - </div>
                                                            }
                                                        </div>
                                                    </Table.Cell>

                                                    <Table.Cell>{
                                                        (request.postProcessing && request.postProcessing.quickInfo) ? 
                                                        request.postProcessing.quickInfo : "-" }</Table.Cell>
                                                    
                                                </Table.Row>
                                            </>
                                        })  
                                    } 
                                </Table.Body>
                            </Table>
                            <Pagination className={"padination-container"} activePage={paginationState.activePage} 
                                totalPages={paginationState.recordCount && paginationState.recordCount / paginationState.rowsPerPage || 1} 
                                disabled={loading}
                                onPageChange={(e, d) => onPageChange(e, d)}
                            />
                        </>  : null
                    }
                    

                    {  window.innerWidth  < 768 ?
                        <>   
                            <Pagination className={"padination-container"} activePage={paginationState.activePage} 
                                totalPages={paginationState.recordCount && paginationState.recordCount / paginationState.rowsPerPage || 1} 
                                disabled={loading}
                                onPageChange={(e, d) => onPageChange(e, d)}
                            />
                            <Grid className={"request-detail-card-grid"}>
                                {
                                    customerRequests.sort((a,b) => moment(b.initiated) -  moment(a.initiated)).map((request, requestIndex) => {
                                        return (
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <RequestDetailCard request={request} 
                                                        onRequestUpdateButtonClick={(token) => onRequestUpdateButtonClick(token)}
                                                        onRequestInvoiceDetailButtonClick={(req) => onRequestInvoiceDetailButtonClick(req)} 
                                                        onRequestDeleteButtonClick={(req) => onRequestDeleteButtonClick(req)}
                                                        onRequestBookButtonClick={(request) => onBookRequestClicked(request.scServiceID, moment(request.bookingDate), request.scRequestID)}
                                                        handleStatusUpdateClick={(request) => handleStatusUpdateClick(request)}
                                                        isSellerDriver
                                                        handleRequestNotesClick={(request) => { handleRequestNotesClick(request) }}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                        )
                                    })
                                }
                            </Grid> 
                            <Pagination className={"padination-container"} activePage={paginationState.activePage} 
                                totalPages={paginationState.recordCount && paginationState.recordCount / paginationState.rowsPerPage || 1} 
                                disabled={loading}
                                onPageChange={(e, d) => onPageChange(e, d)}
                            />
                        </> : null
                    }

                   <RequestNotesModal
                       selectedRequest={selectedRequest}
                       isOpen={requestNotesModalOpen}
                       onClose={() => handleRequestNotesModalClose()}
                       header={"Notes"}
                   ></RequestNotesModal>

                    <RequestInvoiceDetailModal
                        isOpen={requestInvoiceDetailModalOpen}
                        onClose={() => handleInvoiceDetailModalClose()}
                        onSubmit={() => {}}
                        header={"Invoice Details"}
                        submitButtonText={"Save"}
                        selectedRequest={selectedRequest}
                        onCustomerNameChangeSubmit={() => {
                            loadData();
                        }}
                        onInvoiceItemsUpdate={() => {
                            loadData();
                        }}
                    ></RequestInvoiceDetailModal>

                            <Modal
                                open={showBookModal}
                                onClose={() => this.setState({ showBookModal: false })}
                                className="booking-modal"
                            >
                                <Modal.Header className="booking-modal-header">Select Booking Date & Time</Modal.Header>
                                <Modal.Content className='booking-modal-content'>
                                    <div className='booking-date-with-reset-div'>
                                        <span className="booking-date-control-div">
                                        
                                            <img className="calendar-image" src={Calendar}></img>
                                            <DatePicker
                                            
                                                showIcon
                                                selected={bookDate}
                                                onChange={(date) => onBookingDateChanged(date)}
                                                showTimeSelect
                                                dateFormat="MM/dd/yyyy h:mm aa"
                                                timeIntervals={15}
                                                className="booking-date-picker"
                                                calendarClassName="control-calendar"
                                                minDate={new Date()}
                                                
                                            />
                                            
                                         
                                        </span>
                                        {
                                        isBooked ?
                                            <span className='reset-image-div'>
                                                <img className="reset-image" src={deleteImg} onClick={() => onDeleteBooking()}></img>
                                            </span>
                                        : ""
                                        }                                          
                                    </div>

                                </Modal.Content>
                                <Modal.Actions className="booking-modal-action">
                                    <div className="div-action">
                                        <span className="span-btn-cancel">
                                            <Button onClick={() => setShowBookModal(false)} className="btn-action btn-action-cancel">
                                                Cancel
                                            </Button>
                                        </span>
                                        <span className="span-btn-update">
                                            <Button
                                                content='Done'
                                                positive
                                                onClick={() => onSubmitBookingDate()}
                                                className="blue btn-action btn-action-update"
                                            />
                                        </span>
                                    </div>
                                </Modal.Actions>
                            </Modal>
                            <Modal
                                open={showDispatchStatusUpdateModal}
                                className="dispatch-status-modal"
                            >
                                <Modal.Header className="dispatch-status-modal-header">Update Status</Modal.Header>
                                <Modal.Content className='dispatch-status-modal-content'>
                                    <div className='content-div'>
                                        <div className="dispatch-status-dropdown-container">
                                            <Dropdown
                                                key={"dispatch-status-dropdown"}
                                                options={selectedRequest.dispatchRequest?.status?.nextStatus?.map((status) => ({ key: status.value, text: status.cta, value: status.value })) || []}
                                                selection
                                                className={"multi-select dispatch-status-dropdown"}
                                                value={selectedDispatchStatus}
                                                deburr={true}
                                                selectOnBlur={false}
                                                onChange={(e, data) => {
                                                    setSelectedDispatchStatus(data.value)
                                                }}
                                                >
                                            </Dropdown>
                                        </div>
                                    </div>
                                </Modal.Content>
                                <Modal.Actions className="dispatch-status-modal-action">
                                    <div className="div-action">
                                        <span className="span-btn-cancel">
                                            <Button onClick={() => setShowDispatchStatusUpdateModal(false)} className="btn-action btn-action-cancel">
                                                Cancel
                                            </Button>
                                        </span>
                                        <span className="span-btn-update">
                                            <Button
                                                content='Done'
                                                positive
                                                onClick={() => {
                                                    const dispatchID = selectedRequest.dispatchRequest?.dispatchID;
                                                    const statusID = selectedDispatchStatus;
                                                    handleDispatchRequestStatusUpdate(dispatchID, statusID);
                                                }}
                                                className="blue btn-action btn-action-update"
                                            />
                                        </span>
                                    </div>
                                </Modal.Actions>
                            </Modal>
                </>
                : 
                <>
                    <div className={"no-request-heading-container"}>
                        <h1>
                            No Dispatched Request Found
                        </h1>
                    </div>
                </>
            }  
            {
                window.innerWidth  < 768  && currentUser && currentUser.Seller && currentUser.Seller.isSaasEnabled ? 
                <div onClick={disableAddCustomerRequestButton ? () => {} : ()=> {handleAddCustomerRequestButtonClick()}} 
                className={`add-request-float-button-container ${disableAddCustomerRequestButton ? " disabled" : ""}`}>
                    <p>
                        +
                    </p>
                </div> : ""
            }
             
        </div>
        <Confirm open={showDeleteConfirmModal} className='delete-confirm-modal'
        onCancel={onCloseDeleteConfirmModal}
        onConfirm={onSCRequestDeleteConfirm}
        content='Are you sure you want to delete this service request ? This action cannot be undone.'
        cancelButton='No'
        confirmButton="Yes, Delete"
        ></Confirm>
        </>
    )
}   

export default  withRouter(CustomerRequestsContainer)
